module.exports = __webpack_public_path__ + "static/media/sitewebcnmmg-mf.2be1b991.webp";